function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Custom/User");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Custom/User",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.6929014,9.62109942 L24.8893869,11.4489319 C28.3858923,12.971859 30.7362745,16.3232267 30.9771638,20.1293834 C30.9771638,20.1293834 30.9771638,20.1293834 30.9771638,20.1293834 C31.3152037,25.4705635 27.8229396,28.6163382 25.6263698,30.2682227 C24.16199,31.369479 20.5035066,31.2277217 14.6509197,29.8429508 C11.2568998,26.2191733 9.72047554,23.3680118 10.041647,21.2894664 C10.5234043,18.1716484 11.2642392,12.1489532 12.8767923,10.7778677 C12.8767923,10.7778677 12.8767923,10.7778677 12.8767923,10.7778677 L12.8767923,10.7778677 C15.0477815,8.93196752 18.0803118,8.48315538 20.692906,9.62108887 Z",
  id: "User-Icon",
  stroke: "#EFCEA3",
  strokeWidth: 2,
  fill: "#FCF6E3",
  transform: "translate(20.500000, 19.999986) rotate(120.000000) translate(-20.500000, -19.999986) "
}));

var SvgBullet = function SvgBullet(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBullet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bullet.4f75f659.svg";
export { ForwardRef as ReactComponent };